import { render, staticRenderFns } from "./userDet.vue?vue&type=template&id=522d764c&scoped=true&"
import script from "./userDet.vue?vue&type=script&lang=js&"
export * from "./userDet.vue?vue&type=script&lang=js&"
import style0 from "./userDet.vue?vue&type=style&index=0&id=522d764c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d764c",
  null
  
)

export default component.exports